import { Col } from "antd";

const StatisticsSingle = ({ statistics }: { statistics: any }) => {
  const { icon: Icon, title, progress } = statistics;
  return (
    <Col className="w-full h-[150px] bg-neutral-100 rounded-xl py-2 px-5 flex items-center justify-center">
      <div className="flex flex-col gap-5">
        <div className="flex items-center fill-primary-600">
          <Icon height={50} />
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="text-neutral-600">{title}</div>
          <div className="text-primary-500 font-semibold">{progress}</div>
        </div>
      </div>
    </Col>
  );
};

export default StatisticsSingle;
